import { freeze, chain } from 'icepick';
import type { Action } from '../../../actions';
import { SET_APP_DATA } from '../../../actions/app';
import { UPDATE_VERSION } from '../../../actions/version';
import type { VersionsState } from './types';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const defaultState = freeze({}) as VersionsState;

export const versionsReducer = (
	state: VersionsState = defaultState,
	action: Action,
): VersionsState => {
	switch (action.type) {
		case SET_APP_DATA:
			return action.payload.entities.versions ? freeze(action.payload.entities.versions) : state;
		case UPDATE_VERSION:
			return chain(state)
				.setIn([String(action.payload.version.id)], action.payload.version)
				.value();
		default:
			return state;
	}
};
